<template>
  <div :class="['wim-landing', 'tva-row', $mq === 'mobile' ? 'active' : '']" id="wim-section-0" ref="landing">
    <div class="wim-landing-image" ref="videoContainer" id="wim-landing-video-container">
      <video autoplay loop muted playsinline="true" ref="video" :poster="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${content.video}.jpg`" >
        <source :src="`${baseUrl}images/${content.video}.mp4`" type="video/mp4">
      </video>
    </div>
    <div class="wim-landing-title first">
      <span><h1>{{content.firstTitle}}</h1></span> 
    </div>
    <div class="wim-landing-title second">
      <span><h1>{{content.secondTitle}}</h1></span>
    </div>
    <div class="wim-landing-names">
      <p v-html="content.firstName" class="black">{{content.firstName}}</p>
      <p v-html="content.secondName" class="black">{{content.secondName}}</p>
    </div>
  </div>
</template>
<script>
import ScrollMagic from "scrollmagic"
export default {
  props: ["content", "active"],
  mounted() {
    this.$nextTick(()=>{
      this.listenWindowScroll()
      this.setScrollmagic()
    })
  },
  data() {
    return {
      scrollPos: 0,
      scrollDirection:'',
      baseUrl: process.env.BASE_URL
    }
  },
  watch: {
    active(value) {
      let video = this.$refs.video;
      value ? video.play() : video.pause()
    }
  },
  methods: {
    listenWindowScroll() {
      window.addEventListener('scroll', () => {
        if (this.$mq !== 'mobile') {
          if (this.$refs.landing && this.$refs.landing.getBoundingClientRect().bottom < 0) {
            this.$emit('showMenu', true)
          } else {
            this.$emit('showMenu', false)
          }
        }
      });
    },
    setScrollmagic() {
      if (this.$mq !== 'mobile') {
        this.SMcontroller = new ScrollMagic.Controller();
        var bodyHeight = document.body.getBoundingClientRect().bottom
        //landing scene
        new ScrollMagic.Scene({
          triggerElement: this.$refs.landing,
          triggerHook: 0.1,
          reverse: true,
          offset: 200,
          duration: bodyHeight
        })
          .setClassToggle(this.$refs.landing, "active")
          // .addIndicators()
          .addTo(this.SMcontroller);

        new ScrollMagic.Scene({
          triggerElement: this.$refs.landing,
          triggerHook: 0.1,
          reverse: true,
          offset: 100,
          duration: 900
        })
          .setPin(this.$refs.landing)
          .addTo(this.SMcontroller);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
h1, p {
  margin: 0;
}
.wim-landing {
  height: 100vh;
  width: 100%;
  position: relative;
  margin: 0 auto;
  display:flex;
  justify-content: center;
  align-items: center;
  .wim-landing-names {
    position: absolute;
    left:0;
    top: calc(40% - 100px);
    transform: translateX(-100px);
    opacity:0;
    transition: transform 500ms ease, opacity 500ms ease;
    transition-delay: 1000ms;
    user-select: none;
  }
  .wim-landing-image {
    width: 100%;
    height: 0%;
    position: relative;
    overflow: hidden;
    padding-bottom: 56.25%;
    transition: transform 1700ms ease;
    transition-delay: 500ms;
    transform: scale(1) translateX(0);
    z-index: -1;
    background: transparent;
    video{
      min-width: 100%;
      max-width: none;
      position: absolute;
      width: calc(100% + 8px);
      top: 0;
      left: -3px;
      &::-webkit-media-controls {
        display: none;
      }
    }
  }
  .wim-landing-title {
    user-select: none;
    position: absolute;
    left:0;
    width: 0;
    white-space: nowrap;
    overflow: hidden;
    transform: translateX(-200px);
    mix-blend-mode: lighten;
    transition: width 1000ms cubic-bezier(.12,.11,.25,1), transform 1000ms cubic-bezier(.12,.11,.25,1);
    &.first {
      top:40%;
      transition-delay: 500ms;
    }
    &.second {
      top: calc(40% + 13vw);
      transition-delay: 700ms;
    }
    span {
      h1 {
        display: inline;
        background: linear-gradient(to right, rgba($red, 1) 0%, rgba($red, 0.7) 100%);
      }
    }
  }
  &.active {
    .wim-landing-title {
      width: 100%;
      transform: translateX(0px);
    }
    .wim-landing-image {
      transform: scale(0.8) translateX(150px);
    }
    .wim-landing-names {
      transform: translateX(0px);
      opacity: 1;
    }
  }
}

@media(max-width:768px) {
  .wim-landing.active {
    height: 70vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .wim-landing-image {
      margin: 0 auto;
      position: static;
      transform: scale(1)  translateY(50px);
    }
    .wim-landing-title {
      width: calc(100% - 10px);
      position: static;
      margin-left:10px;
      &.second {
        margin-top: 15px;
        margin-bottom: 15px;
      }
    }
    .wim-landing-names{
      position: static;
      padding-left:10px;
    }
  } 
}
@media(max-width: 1450px) {
  .wim-landing {
    height: calc(100vh - 100px);
    margin-top: 0px !important;
    width: 100%;
    .wim-landing-names,
    .wim-landing-title {
      left: 5%;
    }
  }
}
</style>